import { operational } from "@mideye/design-tokens";

export const darkColors = operational.aegis.colors.dark;
export const lightColors = operational.aegis.colors.light;
export const riskColors = operational.aegis.risk;
export const chartColors = operational.aegis.chart;

export type ColorMode = "dark" | "light";

export function getColors(mode: ColorMode) {
  return mode === "dark" ? darkColors : lightColors;
}
